(function() {
  angular.module('cfn').directive('fnInputDecimal', inputDecimal);

  inputDecimal.$inject = ['$locale'];
  function inputDecimal($locale) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        fnInputDecimal: '@'
      },
      link: function link(scope, elem, attrs, ngModel) {
        var decimalsAllowed = scope.fnInputDecimal * 1 || 0;

        ngModel.$parsers.push(function(value) {
          if (value) {
            var nthOccurrence = 0;
            var str = ('' + value).replace(',', '.');
            str = str.replace(/[^0-9\\.]+/g, '');
            str = str.replace(/\./g, function(match) {
              nthOccurrence++;
              return nthOccurrence > 1 ? '' : match;
            });

            var posOfSeparator = str.indexOf('.');
            var offset = decimalsAllowed === 0 ? 0 : decimalsAllowed + 1;
            if (posOfSeparator > -1 && posOfSeparator < str.length - offset) {
              str = str.substr(0, posOfSeparator + offset);
            }

            ngModel.$setViewValue(
              str.replace('.', $locale.NUMBER_FORMATS.DECIMAL_SEP)
            );
            ngModel.$render();

            value = parseFloat(convertToFixedDecimal(str));
          }

          return value;
        });

        ngModel.$formatters.push(function(value) {
          return value
            ? convertToFixedDecimal(value).replace(
              '.',
              $locale.NUMBER_FORMATS.DECIMAL_SEP
            )
            : value;
        });

        function convertToFixedDecimal(str) {
          return parseFloat(str).toFixed(decimalsAllowed);
        }
      }
    };
  }
})();
